import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import useSWR from "swr"
import { NetworkApi } from "../../apis"
import { ProductList } from "../../components/buyer-sales/product-list"
import { ProductListSkeleton } from "../../components/buyer-sales/product-list/ProductListSkeleton"
import { TableFrame } from "../../components/delivery/atoms"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"
import { DeniedCard, ListState } from "../../components/ui"
import HttpHandler from "../../utils/http-handler"
import { message } from "../../utils/message"

export function BuyerSalesNew() {
  const { t } = useTranslation(["order", "common", "supplierSales"])
  const navigate = useNavigate()
  const ORD_LIST = usePermission("ORD_LIST")

  const { data: suppliers, isLoading } = useSWR(
    ORD_LIST.hasAccess ? `/ord/network/select/all-suppliers` : null,
    async () => {
      try {
        const res = await NetworkApi.select({ regNumber: "", partnerName: "", limit: 1000 })
        return res || []
      } catch (err) {
        message.error((err as HttpHandler)?.message!)
        return []
      }
    }
  )

  const breadcrumb = [
    { to: "/", label: t("common:breadcrumb.home") },
    { to: "/buyer-sales", label: t("order:buyerSales.breadcrumb") },
    { label: t("order:catalog.title") },
  ]

  if (!ORD_LIST.hasAccess) {
    return (
      <PageLayout title={t("order:catalog.title")} breadcrumb={breadcrumb} noFrame>
        <DeniedCard permission="ORD_LIST" />
      </PageLayout>
    )
  }

  // Supplier list still loading: the same shell as the catalogue, with placeholders.
  if (isLoading) {
    return (
      <PageLayout title={t("order:catalog.title")} breadcrumb={breadcrumb} noFrame>
        <ProductListSkeleton />
      </PageLayout>
    )
  }

  if (!suppliers || suppliers.length === 0) {
    return (
      <PageLayout title={t("order:catalog.title")} breadcrumb={breadcrumb} noFrame>
        <TableFrame>
          <ListState
            state="empty"
            title={t("supplierSales:customer.noSupplier")}
            description={t("supplierSales:customer.noSupplierDescription")}
            action={{ label: t("supplierSales:customer.backToList"), onClick: () => navigate("/buyer-sales") }}
          />
        </TableFrame>
      </PageLayout>
    )
  }

  return <ProductList suppliers={suppliers} onBack={() => navigate("/buyer-sales")} />
}
